module.exports = __webpack_public_path__ + "static/img/logo-20191111.9602222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portal/logo-20191111.png
// module id = Isvy
// module chunks = 1